class ProductTabs extends HTMLElement {
  constructor() {
    super()

    this.windowWidth = window.innerWidth
    this.tabNav = this.querySelector(".product-tabs")
    this.olTabs = this.querySelector(".olTabs")
    this.tabItems = this.querySelectorAll(".product-tab-link")
    this.tabIContent = document.querySelectorAll(".product-tab-content")

    this.tabItems.forEach((item, index) => {
      item.addEventListener("click", this.setActive.bind(this))
      item.addEventListener("click", this.mobileTabNavPosition.bind(this, index))
    })

  }

  setActive(event) {
    const target = event.target
    // console.log("Target: ",target)
    const targetData = target.dataset.tabValue
    // console.log("Target Data: ",targetData)

    const tContent = document.querySelector(`#${targetData}`)
    // console.log("TContent: ",tContent)

    this.tabItems.forEach((item) => {
      item.classList.remove("active")

    })
    target.classList.add("active")

    this.tabIContent.forEach((item) => {
      item.classList.remove("active")
    })
    tContent.classList.add("active")
  }

  mobileTabNavPosition(index, event) {
    let navWidth = 0
    let previousItemWidth = 0
    const itemIndex = index
    const item = event.target
    const itemWidth = item.scrollWidth
    const tabItems = [...this.tabItems]

    const setMobileNavPosition = () => {
      if (this.windowWidth < 1025) {
        for (let i = 0; i < tabItems.length; i++) { navWidth += (tabItems[i].scrollWidth + 40) }
        for (let i = 0; i < itemIndex; i++) { previousItemWidth += (tabItems[i].scrollWidth + 40) }
        const value = itemIndex > 0 ? previousItemWidth + (itemWidth / 2) - 180 : 20
        //const totalWidth = Math.abs(value)
        //const blockWidth = totalWidth - 154
        //console.log(navWidth, previousItemWidth, `translateX(-${blockWidth}px)`)
        this.olTabs.style.transform = `translateX(-${Math.abs(value)}px)`
      }
    }

    setMobileNavPosition()
    window.addEventListener("resize", setMobileNavPosition)
  }

}
customElements.define("product-tabs", ProductTabs)